import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const getUserDetails = async (
  id,
  infotype = "gameHistory",
  filter = "all",
  page = 1,
  limit = 10,
) => {
  const url = `/api/user/oneuser/${id}/${infotype}/${filter}?page=${page}&limit=${limit}`;
  console.log("[api] Fetching user details:", {
    id,
    infotype,
    filter,
    page,
    limit,
    url,
  });

  try {
    const res = await api.get(url);
    console.log("[api] Response:", res.data);
    return res;
  } catch (error) {
    if (error.response) {
      console.error("[api] Response error:", {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
      });
    } else if (error.request) {
      console.error("[api] No response received:", error.request);
    } else {
      console.error("[api] Request setup error:", error.message);
    }
    throw error;
  }
};

export const getUserDetailsById = async (id) => {
  const res = await api.get(`${networkConfig.users.getUserDetails}/${id}`);
  return res.data;
};

export const getUserhistory = async (
  id,
  infotype = "transactions",
  filter,
  page,
  limit,
) => {
  const params = {};
  if (page) params.page = page;
  if (limit) params.limit = limit;
  // if (filter) params.type = filter;
  if (filter && infotype === "game-history") {
    params.mode = filter;
  } else if (filter) {
    params.type = filter;
  }
  const res = await api.get(
    `${networkConfig.users.getUserDetails}/${id}/${infotype}`,
    {
      params,
    },
  );
  return res.data;
};

export const addTransaction = (data) => api.post("/api/transaction/add", data);

export const addPurchasedItem = (userId, data) =>
  api.post(`/api/purchaseItem/add/${userId}`, data);
